export default function locationProvider() {
    return window.location;
}
